import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";

import config from "../config";

import QuoteDetail from "../components/quoteDetail/QuoteDetail";
import CheckoutForm from "../components/checkoutForm/CheckoutForm";

import translations from "../translations/paiement";
import headerTranslations from "../components/header/header-translations";
import { PhoneIcon } from "../components/articlesList/BlogIcons";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
const stripePromise = loadStripe(config["stripe-public-key"]);

// Stripe's payment form, in the site's fonts and colours.
const stripeAppearance = {
  theme: "stripe",
  variables: {
    colorPrimary: "#11636b",
    colorText: "#10141a",
    borderRadius: "10px",
    fontFamily: "'Work Sans', system-ui, sans-serif",
  },
};
const stripeFonts = [{ cssSrc: "https://fonts.googleapis.com/css2?family=Work+Sans:wght@400;500;600&display=swap" }];

const Paiement = (props) => {
  let [searchParams] = useSearchParams(),
    id = searchParams.get("id"),
    hash = searchParams.get("hash"),
    [quote, setQuote] = useState([]),
    [options, setOptions] = useState([]),
    navigate = useNavigate()
  ;

  document.title = translations[props.lang].meta.title;

  useEffect(() => {
    if(id===null||hash===null){
      navigate((props.lang==='fr'?'/':'/'+props.lang));
      return;
    }
    axios
      .get(
        config["api-endpoint"] + "/quotes/" + id + "/?paiement_hash=" + hash,
        {
          headers: {
            "x-api-key": config["x-api-key"],
          },
        }
      )
      .then((res) => {
        if(res.status===404 || res.data.errorType === 'BSONTypeError'){
          navigate((props.lang==='fr'?'/':'/'+props.lang));
        }
        if(res.status===502){
          navigate((props.lang==='fr'?'/':'/'+props.lang));
        }
        if (res.data.status === "Fermé / Gagné") {
            navigate((props.lang==='fr'?'':'/'+props.lang)+"/devis-reservation-vtc/success");
        }

        res.data.id = res.data._id.substring(0, 7);
        var domain = res.data.email.split("@")[1][0];
        var dI = res.data.email.split("@")[1].split(".")[0].length;
        for (var i = 0; i < dI - 1; i++) {
          domain += "*";
        }
        domain += "." + res.data.email.split("@")[1].split(".")[1];
        var user = res.data.email.split("@")[0][0];
        var uI = res.data.email.split("@")[0].length;
        for (var j = 0; j < uI - 1; j++) {
          user += "*";
        }

        res.data.emailObs = user + "@" + domain;
        setQuote(res.data);
      })
      .catch((err) => {
        console.error(err);
        navigate((props.lang==='fr'?'':'/'+props.lang));
      });

    axios
      .get(
        config["api-endpoint"] +
          "/quotes/" +
          id +
          "/payment-intent/?paiement_hash=" +
          hash,
        {
          headers: {
            "x-api-key": config["x-api-key"],
          },
        }
      )
      .then((res) => {
        console.log(res.status)
        if(res.status===502){
          navigate((props.lang==='fr'?'/':'/'+props.lang));
        }
        setOptions({
          clientSecret: res.data.clientSecret,
          locale: props.lang,
          appearance: stripeAppearance,
          fonts: stripeFonts,
        });
      })
      .catch((err) => {
        console.error(err);
        navigate((props.lang==='fr'?'':'/'+props.lang));
      });
  }, [id, hash, props.lang, navigate]);

  const t = translations[props.lang];

  return (
    <div className="quote">
      <div className="pay-page">
        <div className="quote-intro">
          <span className="eyebrow">{t.eyebrow}</span>
          <h1>{t.title}</h1>
          <p className="lead">{t.lead}</p>
        </div>
        <div className="pay-layout">
          <div className="pay-summary">
            {quote !== undefined &&
              quote !== null &&
              quote.hasOwnProperty("email") && (
                <QuoteDetail lang={props.lang} quote={quote} />
              )}
            <div className="pay-help">
              <strong>{t.help}</strong>
              <a href="tel:+33660265336"><PhoneIcon />{headerTranslations[props.lang].phone}</a>
              <a href="mailto:contact@davoyage.com">contact@davoyage.com</a>
            </div>
          </div>
          <div className="pay-checkout">
            {options.clientSecret !== undefined && (
              <Elements stripe={stripePromise} options={options}>
                <CheckoutForm lang={props.lang} quote={quote} />
              </Elements>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Paiement;
